import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { TrendingUp, AlertTriangle, Building, MapPin, Users, Clock, Eye, MessageSquare, Share2, ArrowLeft } from 'lucide-react';
export function AdvocacyTrendingDetailPage() {
  const {
    id
  } = useParams();
  const issue = {
    id: id || '1',
    title: 'Delayed Possession - Green Valley Phase 2',
    project: 'Green Valley Phase 2',
    developer: 'ABC Developers',
    location: 'Hinjewadi, Pune',
    category: 'Possession Delay',
    postCount: 24,
    affectedBuyers: 156,
    views: 1847,
    trend: '+45%',
    severity: 'high',
    lastUpdate: '2 hours ago',
    description: 'Multiple buyers reporting possession delays of 18+ months beyond promised delivery date. Developer citing regulatory approvals but no concrete timeline provided. Original possession date was December 2021, but as of January 2024, no units have been handed over.'
  };
  const relatedPosts = [{
    id: 1,
    author: 'Verified Buyer',
    title: 'No Possession After 2 Years - Green Valley',
    date: '2024-01-20',
    views: 234,
    comments: 12
  }, {
    id: 2,
    author: 'Verified Buyer',
    title: 'Developer Not Responding to Emails',
    date: '2024-01-18',
    views: 189,
    comments: 8
  }, {
    id: 3,
    author: 'Verified Buyer',
    title: 'Legal Notice Sent - Still No Response',
    date: '2024-01-15',
    views: 156,
    comments: 15
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-1727">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-1728">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-1729">
          <Link to="/" className="flex items-center gap-2" data-id="element-1730">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-1731"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-1732">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-1733">
            <Link to="/" data-id="element-1734">Buy Plots</Link>
            <Link to="/advocacy" data-id="element-1735">Advocacy</Link>
            <Link to="/advocacy/trending" className="text-[#1f2933]" data-id="element-1736">
              Trending
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12 w-full" data-id="element-1737">
        {/* Breadcrumb */}
        <div className="mb-6" data-id="element-1738">
          <Link to="/advocacy" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-1739">
            Advocacy
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-1740">/</span>
          <Link to="/advocacy/trending" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-1741">
            Trending
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-1742">/</span>
          <span className="text-sm text-gray-900" data-id="element-1743">Issue #{issue.id}</span>
        </div>

        <Link to="/advocacy/trending" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6" data-id="element-1744">
          <ArrowLeft className="w-4 h-4" data-id="element-1745" />
          Back to Trending Issues
        </Link>

        {/* Issue Header */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-1746">
          <div className="flex items-center gap-3 mb-4" data-id="element-1747">
            <span className={`px-3 py-1 text-xs font-bold rounded border ${issue.severity === 'high' ? 'bg-red-100 text-red-800 border-red-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-1748">
              {issue.severity === 'high' ? 'HIGH SEVERITY' : 'MEDIUM SEVERITY'}
            </span>
            <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-1749">
              {issue.category}
            </span>
            <span className="px-3 py-1 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded" data-id="element-1750">
              TRENDING {issue.trend}
            </span>
          </div>

          <h1 className="text-4xl font-bold mb-4" data-id="element-1751">{issue.title}</h1>

          <div className="flex items-center gap-6 text-sm text-gray-600 mb-6" data-id="element-1752">
            <span className="flex items-center gap-2" data-id="element-1753">
              <Building className="w-4 h-4" data-id="element-1754" />
              <span className="font-bold" data-id="element-1755">{issue.project}</span>
            </span>
            <span className="flex items-center gap-2" data-id="element-1756">
              <MapPin className="w-4 h-4" data-id="element-1757" />
              {issue.location}
            </span>
            <span className="text-gray-500" data-id="element-1758">by {issue.developer}</span>
          </div>

          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-1759">
            {issue.description}
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 pt-6 border-t border-gray-200" data-id="element-1760">
            <div className="text-center p-4 bg-gray-50 border border-gray-200" data-id="element-1761">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-1762">
                <AlertTriangle className="w-5 h-5 text-gray-400" data-id="element-1763" />
                <span className="text-2xl font-bold" data-id="element-1764">{issue.postCount}</span>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1765">Advocacy Posts</div>
            </div>
            <div className="text-center p-4 bg-gray-50 border border-gray-200" data-id="element-1766">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-1767">
                <Users className="w-5 h-5 text-gray-400" data-id="element-1768" />
                <span className="text-2xl font-bold" data-id="element-1769">
                  {issue.affectedBuyers}
                </span>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1770">Affected Buyers</div>
            </div>
            <div className="text-center p-4 bg-gray-50 border border-gray-200" data-id="element-1771">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-1772">
                <Eye className="w-5 h-5 text-gray-400" data-id="element-1773" />
                <span className="text-2xl font-bold" data-id="element-1774">{issue.views}</span>
              </div>
              <div className="text-xs text-gray-500" data-id="element-1775">Total Views</div>
            </div>
          </div>
        </div>

        {/* Related Posts */}
        <div className="bg-white border border-gray-300 p-8" data-id="element-1776">
          <h2 className="text-2xl font-bold mb-6" data-id="element-1777">Related Advocacy Posts</h2>

          <div className="space-y-4" data-id="element-1778">
            {relatedPosts.map(post => <Link key={post.id} to={`/advocacy/post/${post.id}`} className="block p-6 border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-1779">
                <div className="flex items-start justify-between mb-3" data-id="element-1780">
                  <div className="flex-1" data-id="element-1781">
                    <span className="px-2 py-0.5 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded mb-2 inline-block" data-id="element-1782">
                      VERIFIED BUYER
                    </span>
                    <h3 className="text-lg font-bold hover:text-blue-600" data-id="element-1783">
                      {post.title}
                    </h3>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-1784">
                      by {post.author}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-1785">
                  <span className="flex items-center gap-1" data-id="element-1786">
                    <Clock className="w-4 h-4" data-id="element-1787" />
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1788">
                    <Eye className="w-4 h-4" data-id="element-1789" />
                    {post.views}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-1790">
                    <MessageSquare className="w-4 h-4" data-id="element-1791" />
                    {post.comments}
                  </span>
                </div>
              </Link>)}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 bg-blue-50 border border-blue-200 p-8 text-center" data-id="element-1792">
          <h3 className="text-xl font-bold mb-3" data-id="element-1793">Facing a Similar Issue?</h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1794">
            Share your experience to help other buyers and contribute to
            collective advocacy efforts.
          </p>
          <Link to="/advocacy/submit" className="inline-block px-8 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1795">
            Submit Your Advocacy Post
          </Link>
        </div>
      </main>

      <Footer data-id="element-1796" />
    </div>;
}